import { CustomTable } from './table/Table';
import { CustomButton } from './button/Button';
import { Loading } from './loading/Loading';
import { CustomInput } from './input/Input';

const SharedComponents = { CustomTable, CustomButton, Loading, CustomInput };

export default SharedComponents;
